import { render, staticRenderFns } from "./OnboardingWelcomeModal.vue?vue&type=template&id=0f9686ad"
import script from "./OnboardingWelcomeModal.vue?vue&type=script&lang=js"
export * from "./OnboardingWelcomeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports